/**
 * Shared S3 configuration for WordDrift game assets
 * Used by both deployment scripts and frontend code
 */

import dictionaryVersionJson from './dictionary-version.json';
import puzzlesVersionJson from './puzzles-version.json';

// S3 Configuration
export const S3_CONFIG = {
  BUCKET_NAME: 'casual-web-games-assets',
  REGION: 'us-east-2',
  GAME_FOLDER: 'word-drift'
};

// Dictionary version for cache-busting (auto-updated by deploy script)
export const DICTIONARY_VERSION: string = dictionaryVersionJson.DICTIONARY_VERSION;

// Puzzles version for cache-busting (auto-updated by deploy script)
export const PUZZLES_VERSION: string = puzzlesVersionJson.PUZZLES_VERSION;

// Derived values
export const PUZZLES_S3_KEY = `${S3_CONFIG.GAME_FOLDER}/puzzles.json`;

// Full S3 URL for the dictionary (using path-style URL for better compatibility)
// export const DICTIONARY_URL = `https://s3.${S3_CONFIG.REGION}.amazonaws.com/${S3_CONFIG.BUCKET_NAME}/${DICTIONARY_S3_KEY}`;

// Full cloudfront URL for the dictionary (if using CloudFront)
export const DICTIONARY_URL = `https://d1q1fzcw0aqz2j.cloudfront.net/${S3_CONFIG.GAME_FOLDER}/dictionary.${DICTIONARY_VERSION}.json`;
export const PUZZLES_URL = `https://d1q1fzcw0aqz2j.cloudfront.net/${S3_CONFIG.GAME_FOLDER}/puzzles.${PUZZLES_VERSION}.json`;

// Embeddings URLs (version 1 for initial release)
export const EMBEDDINGS_VERSION = '1';
export const EMBEDDINGS_BIN_URL = `https://d1q1fzcw0aqz2j.cloudfront.net/${S3_CONFIG.GAME_FOLDER}/embeddings.${EMBEDDINGS_VERSION}.bin`;
export const EMBEDDINGS_METADATA_URL = `https://d1q1fzcw0aqz2j.cloudfront.net/${S3_CONFIG.GAME_FOLDER}/embeddings.${EMBEDDINGS_VERSION}.json`;
